import { useNavigate } from "react-router-dom";
import withLoader from "../../components/layouts/WithLoader"
import { useEffect, useState } from "react";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import TierAccountService from "../../services/PayementSolde/TierAccountService";
import DataTableWalletClient from "./DataTableWalletClient";



const WalletClient = ({ startLoading, stopLoading }) => {
    const navigate = useNavigate();
    const [listTiersAccounts, setListTiersAccounts] = useState([]);

    useEffect(() => {
        startLoading()
        setListTiersAccounts([])
        TierAccountService.getAllWalletClient(getCurrentUserId()).then((response)=>{
            setListTiersAccounts(response.data)
        }).catch((error)=>{

        }).finally(()=>{
            stopLoading();
        })
    },[])

    const navigateToAddWalletClient = () => {
      navigate("/addWalletClient");
    };

    return (<div className="content-wrapper" style={{ marginTop: "0" }}>
        <div className="content ">
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-12">
                        <div class="card  mt-3">
                            <div class="card-body">
                                <h5 class="card-title">Ajouter Wallet Client </h5>

                                <button
                                    class="btn btn-dark  float-right"
                                  onClick={navigateToAddWalletClient}
                                >
                                    <i class="fas fa-plus"></i>
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
                {listTiersAccounts.length > 0 && (
                <DataTableWalletClient listTiersAccounts={listTiersAccounts} />
              )}
            </div>
        </div>
    </div>)


}
export default withLoader(WalletClient)